/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/aria-role */
// eslint-disable-next-line no-use-before-define
import React, { useState } from 'react'
import { Icon, mediaQueries, Select } from '@centivo/react-components'
import styled from 'styled-components'

import { SearchBarForm } from 'src/refactor/components/SearchBarForm'
import { ContentSection } from 'src/refactor/structure'

import { useMediaContext } from 'src/context/responsive'
import { CATEGORY } from '../../../../helpers/constants'
import { SearchBarButtonSlice } from './SearchBarButtonSlice'
import { useSearchBarFunctions } from './useSearchBarFunctions'

const StyledContentSection = styled(ContentSection)`
  @media ${mediaQueries.mobile} {
    padding-bottom: calc(6.25rem - 2rem) !important;
  }

  aside {
    @media ${mediaQueries.mobile} {
      margin-top: 2.5rem;
    }

    margin-top: 2.625rem;

    display: flex;
    justify-content: center;
  }
`

const SearchBarContentSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2.5rem;

  .network-selector {
    max-width: 430px;
    width: 100%;

    @media ${mediaQueries.desktop} {
      width: 440px;
      max-width: unset;
    }

    * {
      font-weight: 400;
    }
  }

  .centivo--select__control {
    border-radius: 10px;

    label {
      color: ${({ theme }) => theme.palette.brand.gray};
    }
  }

  .centivo--select__single-value,
  .centivo--select__placeholder {
    color: ${({ theme }) => theme.palette.brand.darkGray};
  }

  svg {
    color: ${({ theme }) => theme.palette.brand.brown};
  }

  .icon-centivo--slice-cancel {
    color: ${({ theme }) => theme.palette.brand.lightGray};
  }

  .icon-centivo--alert-circle {
    color: ${({ theme }) => theme.palette.ui.error};
  }

  .centivo--select__menu {
    border-radius: 10px;

    box-shadow: none;
    border-style: solid;
    border-width: 1px;
    border-color: ${({ theme }) => theme.palette.brand.lightGray};
  }

  .centivo--select__menu-list {
    padding: 0.5rem 0 0.75rem 0;

    div {
      padding: 0.531rem 0.75rem 0.531rem 0.75rem;

      font-weight: 400;
      color: ${({ theme }) => theme.palette.brand.darkGray};
      font-size: 1rem;
      line-height: 1.44rem;
    }
  }
`

const SearchBarTitle = styled.h2`
  color: ${({ theme }) => theme.palette.brand.darkGreen};
  font-size: 1.875rem;
  font-weight: 500;
  line-height: 2.625rem;
  margin-bottom: 0.75rem;
  text-align: center;
`

const SearchBarButtonsGroup = styled.div`
  align-items: start;
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
`

const SearchBarMessage = styled.p`
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 140%;
  color: ${({ theme }) => theme.palette.brand.darkGray};
  max-width: 56.25rem;
`

export const SearchBarSlice = () => {
  const [openNetworkSelect, setOpenNetworkSelect] = useState(false)
  const { isMobileView } = useMediaContext()

  const {
    state,
    networkSelectionEnabled,
    category,
    shouldShowDisclaimer,
    disableTabButtons,
    planNetworkOptions,

    handleNetworkSelected,
    toggleCategory,
    onSubmit,
  } = useSearchBarFunctions()

  const handleNetworkSelectOnFocus = (trigger: boolean) => {
    setTimeout(() => {
      !trigger ? setOpenNetworkSelect(true) : null
    }, 200)
    return null
  }

  return (
    <StyledContentSection id="find-a-doctor">
      <SearchBarContentSection>
        {networkSelectionEnabled && (
          <>
            <SearchBarTitle>Select your network</SearchBarTitle>
            <div
              id="select-wrapper"
              onClick={() => setOpenNetworkSelect(!openNetworkSelect)}
              className={openNetworkSelect ? 'select-input-focus' : ''}
            >
              <Select
                closeMenuOnSelect
                aria-label="Select your network"
                className="network-selector"
                placeholder="Select"
                options={planNetworkOptions}
                onSelect={handleNetworkSelected}
                onFocus={() => handleNetworkSelectOnFocus(openNetworkSelect)}
                isSearchable={false}
                value={state.selectedPlan}
                dropdownIcons={{
                  iconClosed: 'slice-chevron-down',
                  iconOpen: 'slice-chevron-up',
                }}
                clearIcon="slice-cancel"
                isClearable
                float
                menuIsOpen={openNetworkSelect}
              />
            </div>
          </>
        )}
      </SearchBarContentSection>
      {!disableTabButtons && (
        <SearchBarButtonsGroup>
          <SearchBarButtonSlice
            selected={category === CATEGORY.DOCTOR}
            onClick={() => toggleCategory(CATEGORY.DOCTOR)}
            title="Doctor"
            icon={
              <Icon
                aria-hidden
                icon="slice-doctor"
                size={isMobileView ? '3.798rem' : '5rem'}
              />
            }
          />
          <SearchBarButtonSlice
            selected={category === CATEGORY.FACILITY}
            onClick={() => toggleCategory(CATEGORY.FACILITY)}
            title="Facility"
            icon={
              <Icon
                aria-hidden
                icon="slice-health"
                size={isMobileView ? '3.798rem' : '5rem'}
              />
            }
          />
        </SearchBarButtonsGroup>
      )}
      {!disableTabButtons && category && (
        <SearchBarForm
          category={category ?? CATEGORY.DOCTOR}
          onSubmit={onSubmit}
        />
      )}
      {!disableTabButtons && shouldShowDisclaimer && category && (
        <aside>
          <SearchBarMessage>
            The Centivo Network provider directory is updated regularly
            throughout the year. Please check that a provider is in-network for
            your plan by searching for them in the directory before your
            appointment or receiving care. If you need help searching for a
            provider, want to confirm a provider is in-network or if you think
            any information in the directory isn’t accurate, please call Centivo
            Member Care.
          </SearchBarMessage>
        </aside>
      )}
    </StyledContentSection>
  )
}
